import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { DeficiencyList, DeficiencyListCollection } from './deficiencyList.types';

const useDeficiencyOnInspectionLevel = (assetInspectionId: number) => {
  const getDeficienciesQuery = useCallback(
    (collection: DeficiencyListCollection) =>
      collection?.find({
        selector: {
          $and: [{ assetInspectionId }, { isDelete: 'False' }],
        },
      }),
    [assetInspectionId],
  );

  const { result } = useRxData<DeficiencyList>(
    RxdbCollectionName.DEFICIENCY_LIST,
    getDeficienciesQuery,
  );

  return { deficiencies: result };
};

export default useDeficiencyOnInspectionLevel;
